<script>
import Vue from 'vue'
import con from '@services/connection'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { cadastroClientes } from '@constants/URL'
import { MODAL, RELOAD } from '@constants/Text'
import { possivelJSON } from '@utils/Format'
import api from '@plugins/axios'
import { apiPortfolioPortfolioModels } from '@modules/portfolio/api/apiPortfolioPortfolioModels'
import SectionTitle from '@components/section-title'
import ClientFields from '@modules/clients/components/client-fields/client-fields.vue'
import TabelaPlanilha from '@components/tabela-planilha'

export default {
  components: {
    SectionTitle,
    TabelaPlanilha,
    ClientFields,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      api: api,
      loadingNovo: false,
      profissionais: [],
      profissional_responsavel: {},
      busModal: new Vue(),
      busSecond: new Vue(),
      // Bus PRÓPRIO do modal aninhado "Novo cliente". `busSecond` é
      // compartilhado com o modal de importação de planilha, então emitir nele
      // abriria os dois ao mesmo tempo.
      busNewClient: new Vue(),
      clientFieldsResetKey: 0,
      nome: '',
      email: '',
      data_nascimento: '',
      telefone: '',
      cpf: '',
      tags: null,
      patrimonio: '',
      perfil: '',
      dataInicioFee: '',
      qualificado: false,
      pf_pj: false,
      codigo_corretora: '',
      assessor_master: '',
      assessores_master: [],
      assessor: '',
      assessores: [],
      new_client: {},
      file: '',
      file_name: '',
      html: {},
      link_planilha: '',
      is_valid: '',
      errors: [],
      warnings: [],
      loading: false,
      formValid: false,
      dragging: false,
      prospect: false,
      investidorProfissional: false,
      adesaoConsentimentoRisco: false,
      dataAdesaoConsentimentoRisco: '',
    }
  },
  computed: {
    perfis() {
      return this.$store.getters['portfolio/portfolioModels'].map(
        (item) => item.nome
      )
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    escritorio() {
      return this.usuarioAtual.escritorio
    },
    clientData: {
      get() {
        return {
          nome_cliente: this.nome,
          email: this.email,
          data_nascimento: this.data_nascimento,
          telefone: this.telefone,
          perfil: this.perfil,
          pl_potencial: this.patrimonio,
          cpf: this.cpf,
          codigo_corretora: this.codigo_corretora,
          data_inicio_fee: this.dataInicioFee,
          qualificado: this.qualificado,
          cliente_pj: this.pf_pj,
          cliente_prospect: this.prospect,
          investidor_profissional: this.investidorProfissional,
          adesao_consentimento_risco: this.adesaoConsentimentoRisco,
          data_adesao_consentimento_risco: this.dataAdesaoConsentimentoRisco,
          id_profissional_responsavel: this.profissional_responsavel,
          assessores_comerciais: this.profissionais,
          tags: this.tags,
        }
      },
      set(value) {
        this.applyClientData({ value })
      },
    },
  },
  created() {
    // UM ouvinte por instância: quando montado dentro de um shell com bus local
    // (ex. left-bar-actions), escuta esse bus; quando montado no host global
    // (global-modals, sem bus), escuta o GlobalBus. Antes registrava os dois
    // incondicionalmente, o que abria 2 modais quando havia instância local +
    // global respondendo ao mesmo GlobalBus.
    this.eventBus = this.bus || GlobalBus
    this.eventBus.$on(MODAL.CADASTRAR_CLIENTES, this.openFromBus)
  },
  beforeDestroy() {
    if (this.eventBus) {
      this.eventBus.$off(MODAL.CADASTRAR_CLIENTES, this.openFromBus)
    }
  },
  methods: {
    // Aceita o payload legado (boolean: abre/fecha a tela-hub) e o payload em
    // objeto `{ direct: true }`, que abre SÓ o formulário de novo cliente, sem
    // a tela-hub (usado pela Visão Geral do Compliance). O BaseModal "Novo
    // cliente" é irmão do hub no template, então já está montado e ouvindo
    // `busNewClient` — não depende do conteúdo lazy do v-dialog do hub.
    openFromBus(value) {
      if (value && typeof value === 'object' && value.direct) {
        this.openNewClientForm()
        return
      }
      const shouldOpen = value && typeof value === 'object' ? true : !!value

      this.busModal.$emit('dialog', shouldOpen)
      this.resetClientForm()
      this.collectLink()
    },
    // Abre o formulário "Novo cliente" com estado limpo. Usado pelo botão da
    // tela-hub e pelo modo direto.
    openNewClientForm() {
      this.resetClientForm()
      this.busNewClient.$emit('dialog', true)
    },
    applyClientData({ value }) {
      const nextData = value || {}
      this.nome = nextData.nome_cliente || ''
      this.email = nextData.email || ''
      this.data_nascimento = nextData.data_nascimento || ''
      this.telefone = nextData.telefone || ''
      this.perfil = nextData.perfil || ''
      this.patrimonio = nextData.pl_potencial || ''
      this.cpf = nextData.cpf || ''
      this.codigo_corretora = nextData.codigo_corretora || ''
      this.dataInicioFee = nextData.data_inicio_fee || ''
      this.qualificado = !!nextData.qualificado
      this.pf_pj = !!nextData.cliente_pj
      this.prospect = !!nextData.cliente_prospect
      this.investidorProfissional = !!nextData.investidor_profissional
      this.adesaoConsentimentoRisco = !!nextData.adesao_consentimento_risco
      this.dataAdesaoConsentimentoRisco =
        nextData.data_adesao_consentimento_risco || ''
      this.profissional_responsavel = nextData.id_profissional_responsavel || {}
      this.profissionais = Array.isArray(nextData.assessores_comerciais)
        ? nextData.assessores_comerciais
        : []
      this.tags = Object.prototype.hasOwnProperty.call(nextData, 'tags')
        ? nextData.tags
        : null
    },
    resetClientForm() {
      this.incrementClientFieldsResetKey()
      this.clearData()
      this.refreshClientDependencies()
    },
    incrementClientFieldsResetKey() {
      this.clientFieldsResetKey += 1
    },
    clearData() {
      this.resetFormValidation()
      this.clearClientIdentityFields()
      this.clearClientBusinessFields()
      this.clearClientQualificationFields()
      this.clearProfessionalFields()
      this.clearSpreadsheetFields()
      this.clearUiStateFields()
    },
    refreshClientDependencies() {
      this.coletarPerfis()
      this.collectAssessores()
    },
    resetFormValidation() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
    clearClientIdentityFields() {
      this.nome = ''
      this.email = ''
      this.telefone = ''
      this.data_nascimento = ''
      this.cpf = ''
      this.tags = null
    },
    clearClientBusinessFields() {
      this.perfil = ''
      this.patrimonio = ''
      this.dataInicioFee = ''
      this.codigo_corretora = ''
    },
    clearClientQualificationFields() {
      this.qualificado = false
      this.pf_pj = false
      this.prospect = false
      this.investidorProfissional = false
      this.adesaoConsentimentoRisco = false
      this.dataAdesaoConsentimentoRisco = ''
    },
    clearProfessionalFields() {
      this.assessor_master = ''
      this.assessor = ''
      this.profissionais = []
      this.profissional_responsavel = {}
    },
    clearSpreadsheetFields() {
      this.file = ''
      this.file_name = ''
      this.html = {}
      this.is_valid = ''
      this.errors = []
      this.warnings = []
    },
    clearUiStateFields() {
      this.dragging = false
      this.loading = false
    },
    setAssessor() {
      let id_assessor = this.usuarioAtual.id_interno
      let assessor_master = this.assessores_master.find((value) => {
        return id_assessor === value.id_profissional
      })
      this.assessor_master = assessor_master
      this.profissional_responsavel = { ...assessor_master }
    },
    collectAssessores() {
      con.get(cadastroClientes.get_assessores).then((res) => {
        if (res && res.status === 200) {
          this.assessores = possivelJSON(res.value)
          this.assessores_master = possivelJSON(res.value)
          this.setAssessor()
        }
      })
    },
    openSnack(message, color) {
      store.dispatch('feedback/showSnack', {
        text: message,
        button: true,
      })
    },
    collectLink() {
      this.link_planilha = `${this.api.defaults.baseURL}${cadastroClientes.planilha_modelo}`
    },
    dowloadFile() {
      window.open(this.link_planilha)
    },
    onChange(event) {
      if (!event) return

      const hasInputFiles =
        event.target && event.target.files && event.target.files.length > 0
      const hasDTFiles =
        event.dataTransfer &&
        event.dataTransfer.files &&
        event.dataTransfer.files.length > 0

      if (!hasInputFiles && !hasDTFiles) {
        return
      }

      const file = hasInputFiles
        ? event.target.files[0]
        : event.dataTransfer.files[0]
      if (!file) return

      this.file = file
      this.file_name = file.name
      this.submitFile()
    },
    submitFile() {
      if (this.loading) {
        return
      }

      let files_accepted = [
        '.xls',
        '.xlsx',
        '.csv',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ]

      if (!files_accepted.includes(this.file.type)) {
        this.file_name = this.file
          ? 'Arquivo não compatível, enviar arquivos no formato .xls, .xlsx ou .csv'
          : 'Importe seu CSV'
        return
      }

      this.loading = true
      con
        .post(cadastroClientes.ler_planilha, {
          file: this.file,
        })
        .then((res) => {
          if (res && res.status !== 500) {
            this.html = res.value
            this.is_valid = res.status === 200
            this.errors = res.errors || []
            this.warnings = res.warnings || []
          }
          this.$showSnack({
            text: res.message,
            button: true,
          })

          this.loading = false
        })
    },
    _formatDataNewClient() {
      return {
        id_cliente: 1,
        nome_cliente: this.nome,
        pl_potencial: this.patrimonio,
        perfil: this.perfil,
        qualificado: this.qualificado,
        pessoa_juridica: this.pf_pj,
        data_inicio_fee: this.dataInicioFee,
        codigo_corretora: this.codigo_corretora,
        email: this.email,
        telefone: this.telefone,
        data_nascimento: this.data_nascimento,
        cpf: this.cpf,
        tags: this.tags,
        id_profissional_responsavel:
          this.profissional_responsavel.id_profissional,
        assesores_comerciais: JSON.stringify(this.profissionais),
        prospect: this.prospect,
        cliente_prospect: this.prospect,
        investidor_profissional: this.investidorProfissional,
        adesao_consentimento_risco: this.adesaoConsentimentoRisco,
        data_adesao_consentimento_risco: this.dataAdesaoConsentimentoRisco,
      }
    },
    // Fecha o formulário aninhado e a tela-hub após o cadastro. `busNewClient`
    // é o bus do modal "Novo cliente"; `busSecond` é o do importador de
    // planilha (fechá-lo aqui preserva o comportamento anterior).
    closeAfterCreate(close) {
      if (close) {
        close()
      }
      if (this.busNewClient) {
        this.busNewClient.$emit('dialog', false)
      }
      if (this.busSecond) {
        this.busSecond.$emit('dialog', false)
      }
      if (this.busModal) {
        this.busModal.$emit('dialog', false)
      }
    },

    newClient(close) {
      if (this.loadingNovo) {
        return
      }
      if (!this.$refs.form.validate()) {
        return
      }
      this.loadingNovo = true
      const data = this._formatDataNewClient()
      con.post(cadastroClientes.novo_cliente, data).then((res) => {
        this.loadingNovo = false
        if (res && [201, 200].includes(res.status)) {
          this.openSnack(res.message, 'success')
          this.new_client = res.value
          this.resetClientForm()
          this.closeAfterCreate(close)
          GlobalBus.$emit(RELOAD.CLIENTS, true)
          GlobalBus.$emit(RELOAD.CLIENT_CREATED, res.value)
        } else {
          this.openSnack(
            res && res.message ? res.message : 'Erro ao cadastrar cliente',
            'error'
          )
        }
      })
    },
    importClients(close) {
      if (this.loading) {
        return
      }
      this.loading = true
      let aux = {}
      Object.values(this.html || {}).forEach((value) => {
        Object.entries(value || {}).forEach((entry) => {
          let tmp = aux[entry[0]] || []
          tmp.push(entry[1].data_parsed)
          aux[entry[0]] = tmp
        })
      })
      con
        .post(cadastroClientes.salvar_planilha, {
          table: JSON.stringify(aux),
        })
        .then((res) => {
          if (res && res.status === 200) {
            this.html = res.value
            this.loading = false
            this.$showSnack({
              text: 'Clientes cadastrados com sucesso',
              button: true,
            })
            GlobalBus.$emit(RELOAD.CLIENTS, true)
            if (close) {
              close()
            }
          } else {
            this.loading = false
            this.openSnack(
              res && res.message ? res.message : 'Erro ao salvar planilha',
              'error'
            )
          }
        })
    },
    lastStep(close) {
      this.file_name = ''
      close()
    },
    async coletarPerfis() {
      await apiPortfolioPortfolioModels.carregar()
    },
    openModalCarteiraAdministrada() {
      GlobalBus.$emit(MODAL.CLIENTS_CARTEIRA_ADMINISTRADA)
    },
    validateForm() {
      this.$refs.form.validate()
      return this.formValid
    },
  },
}
</script>

<template>
  <div>
    <BaseModal
      :bus="busModal"
      button-title="Abrir"
      height="600px"
      max-width="90%"
      persistent
    >
      <template v-slot:title>
        <SectionTitle
          title="Cadastro de clientes"
          subtitle="Adicionar clientes na sua base"
        />
      </template>
      <div class="cadastro-cliente">
        <div class="cadastro-cliente__container">
          <div class="cadastro-cliente__card az-card-consolidator">
            <span class="text-heading-medium"> Novo cliente </span>
            <span class="text-sm"> Cadastre seus novos clientes </span>

            <div class="cadastro-cliente__card-actions">
              <BaseButton
                class="cadastro-cliente__card-button"
                primary
                @click="openNewClientForm"
              >
                Novo Cliente
              </BaseButton>

              <BaseButton
                class="cadastro-cliente__card-button"
                primary
                @click="openModalCarteiraAdministrada"
              >
                Carteira Administrada
              </BaseButton>
            </div>
          </div>

          <div class="cadastro-cliente__card az-card-consolidator">
            <span class="text-heading-medium"> Lista de clientes </span>
            <span class="text-sm"> Importe seus clientes</span>

            <div class="cadastro-cliente__card-actions">
              <BaseButton
                class="cadastro-cliente__card-button"
                primary
                outline
                small
                @click="dowloadFile"
              >
                <icon-svg color="primary" name="document-download" />
                Baixar Modelo
              </BaseButton>

              <BaseModal
                :bus="busSecond"
                height="650px"
                max-width="1200px"
                persistent
              >
                <template v-slot:button>
                  <BaseButton class="cadastro-cliente__card-button" primary>
                    Importar Clientes
                  </BaseButton>
                </template>

                <div>
                  <SectionTitle
                    subtitle="Cadastrar clientes em lote"
                    title="Importar clientes"
                  />

                  <div class="uploadBox">
                    <div class="uploadBoxMain">
                      <div
                        :class="dragging ? 'dropAreaDragging' : ''"
                        class="dropArea"
                        style="position: relative"
                        @dragend="dragging = false"
                        @dragenter="dragging = true"
                        @dragleave="dragging = false"
                        @dragover.prevent
                        @drop.prevent="onChange"
                      >
                        <div>
                          <h3>{{ file_name ? file_name : 'Importe seu CSV' }}</h3>
                          <input
                            id="file"
                            accept=".xls,.xlsx,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            name="file"
                            required
                            type="file"
                            @change="onChange"
                          />
                          <p class="help-block">
                            Arraste o arquivo que deseja fazer o upload ou clique
                            para adicioná-lo
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="Object.keys(html || {}).length"
                    :style="{
                      'align-items': 'center',
                      'justify-content': 'center',
                      'margin-top': '10px',
                    }"
                  >
                    <TabelaPlanilha
                      class="table-new-ux"
                      widthTable="100%"
                      :data="html"
                      _id="tabela-conferir-novos-clientes"
                    />

                    <div
                      v-for="(i, idx) in errors"
                      :key="'e' + idx"
                      :style="{ 'margin-top': '20px' }"
                    >
                      <p :style="{ 'font-size': '14px', color: 'red' }">{{
                        i.toString()
                      }}</p>
                    </div>

                    <div
                      v-for="(i, idx) in warnings"
                      :key="'w' + idx"
                      :style="{ 'margin-top': '20px' }"
                    >
                      <p
                        :style="{ 'font-size': '14px', 'font-weight': 'bold' }"
                        class="text-warning"
                      >
                        {{ i.toString() }}
                      </p>
                    </div>
                  </div>
                </div>

                <template v-slot:actions="{ close }">
                  <BaseButton underlined @click="close">Cancelar</BaseButton>

                  <BaseButton
                    :loading="loading"
                    :disabled="!is_valid"
                    primary
                    @click="importClients(close)"
                  >
                    Salvar
                  </BaseButton>
                </template>
              </BaseModal>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
    <!-- "Novo cliente" é IRMÃO do hub (não fica no conteúdo lazy do
         v-dialog dele): monta junto com o componente, então o modo direto
         ({ direct: true }) abre só este modal, sem a tela-hub. -->
    <BaseModal
      :bus="busNewClient"
      height="800px"
      max-width="70%"
      persistent
    >
      <template v-slot:title>
        <SectionTitle
          subtitle="Cadastre o cliente"
          title="Novo cliente"
        />
      </template>

      <div>
        <v-form
          ref="form"
          v-model="formValid"
          class="cadastro-cliente__form"
          data-tour="cp-novo-cliente-form"
          @submit.prevent
        >
          <ClientFields
            :key="clientFieldsResetKey"
            mode="create"
            :profile-items="perfis"
            :profile-loading="
              $store.getters['portfolio/portfolioModelsLoading']
            "
            :professional-items="assessores"
            show-broker-code-tooltip
            :show-partnership-hint="
              $store.getters['parameters/canShow']('partnership')
            "
            responsible-return-object
            :client-data.sync="clientData"
          />

          <div class="text-secondary text-xs mt-5">
            * Campos obrigatórios
          </div>
        </v-form>
      </div>

      <div style="border-top: 1px solid #8e8e8e80; margin-block: 16px">
      </div>

      <template v-slot:actions="{ close }">
        <BaseButton underlined @click="close"> Cancelar </BaseButton>
        <BaseButton
          :loading="loadingNovo"
          primary
          data-tour="cp-novo-cliente-salvar"
          @click="newClient(close)"
        >
          Cadastrar cliente
        </BaseButton>
      </template>
    </BaseModal>
  </div>
</template>

<style lang="sass" module>
.v-text-field v-label
  margin-top: 6px !important

.v-text-field__slot input
  margin-top: 6px !important
</style>

<style lang="sass">
.cadastro-cliente
  &__container
    display: flex
    justify-content: space-between
    gap: 32px

  &__card
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    gap: 24px
    height: 100%
    min-height: 276px
    padding-block: 0px
    flex: 1 1 0

    &-actions
      display: flex
      gap: 24px

    &-button
      min-width: 175px !important

  &__form
    .col-2, .col-4, .col-6, .col-8, .col-12
      padding-block: 0px !important

  &__label
    &--select-multiple .v-autocomplete
      margin-top: 0px !important

.uploadBox
  background: #eee

.uploadBox .uploadBoxMain
  margin-bottom: 1em

.uploadBox .dropArea
  border: 3px dashed var(--primary)
  text-align: center
  font-size: 1.5em
  padding: 40px

.uploadBox .dropArea input
  position: absolute
  cursor: pointer
  top: 0
  right: 0
  width: 100%
  height: 100%
  opacity: 0
</style>
